import template from './amplifyInformation.html';
import './amplifyInformation.scss';
import controller from './amplifyInformation.controller';
let amplifyInformationComponent = {
  restrict: 'E',
  bindings: {
    onClose: '&',
  },
  template,
  controller
};

export default amplifyInformationComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/amplifyInformation/amplifyInformation.component.js